import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { makeRequest } from "../apis/makeRequest";
import { getProducts } from "../apis/backendRequests";
import ProductCardCatalogo from "../components/Catalogo/ProductCardCatalogo";
import { Grid, useMediaQuery } from "@mui/material";
import Carrousel from "../components/Carrousel";
import { useTheme } from "@emotion/react";

const size = (l) => {
  switch (l) {
    case 1:
      return 13;
    case 2:
      return 5;
    case 3:
      return 4;
    default:
      return 3;
  }
};

export default function Catalogo({ inicio = false }) {
  const { searchTerm, categoria, rubro, subRubro, promocion } = useSelector(
    (state) => state.gallery
  );
  const { items } = useSelector((state) => state.cart);
  const { isLoggedIn } = useSelector((state) => state.account);

  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const lastItemRef = useRef()
  const theme = useTheme()
  const mobile = useMediaQuery(theme.breakpoints.down("md"))

  useEffect(() => {
    setPage(1);
  }, [searchTerm, categoria, rubro, subRubro, promocion]);

  useEffect(() => {

    localStorage.setItem("cartItems", JSON.stringify(items));
    localStorage.setItem("orderItems", []);
  }, [items]);

  useEffect(() => {
    let rowsPerPage = inicio ? (mobile ? 10 : 20) : 10
    makeRequest(
      () =>
        getProducts(
          "online",
          1,
          inicio ? rowsPerPage : rowsPerPage * page,
          inicio ? '' : searchTerm,
          inicio ? '' : categoria,
          inicio ? '' : rubro,
          inicio ? '' : subRubro,
          inicio ? 'Destacados' : promocion
        ),
      (res) => setProducts(res.data)
    );
  }, [searchTerm, categoria, rubro, subRubro, page, promocion]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && entries[0].time > 2000) {
          setPage(page + 1);
        }
      },
      { threshold: 0.9 }
    );

    const current = lastItemRef.current;

    if (current) observer.observe(current);

    return () => observer.disconnect(current);
  });


  const productGrid = products.map((product, i) => {
    const slideItemSx = mobile
      ? { width: "100vw", minWidth: 0 }
      : inicio
        ? {
            // clamp evita acumular tamaños raros con zoom; flex evita colapsar el slide
            width: { md: "clamp(200px, 22vw, 360px)" },
            minWidth: 0,
            maxWidth: "100%",
            flex: "0 0 auto",
            minHeight: { md: 400 },
            height: { md: "auto" },
            boxSizing: "border-box",
          }
        : { width: { md: "20vw" }, minWidth: 0, flex: "0 0 auto" }

    return (
      <Grid
        item
        padding={0}
        md={inicio ? 11 : size(products.length)}
        sx={slideItemSx}
        key={product.productId}
        ref={i === 10 * page - 1 ? lastItemRef : null}
      >
        <ProductCardCatalogo product={product} index={i} isClient={isLoggedIn} />
      </Grid>
    );
  });



  return (
    <div>
      <Grid spacing={2} container sx={inicio ? { display: "flex" } : { display: "flex" }}>
        {inicio ? <Carrousel image={productGrid} productsLanzamiento /> : productGrid}
      </Grid>
    </div>
  );
}
